import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-curling",
  "use": "icon-curling-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-curling\"><path d=\"M7.77 3.54a.846.846 0 100 1.692h5.686a2.53 2.53 0 012.489 2.041l.099.498H7.769a.846.846 0 00-.857.846H4.385A3.385 3.385 0 001 12.002v1.692h22v-1.692a3.385 3.385 0 00-3.385-3.385h-1.692a.85.85 0 00-.016-.165l-.303-1.51a4.239 4.239 0 00-4.148-3.402H7.769zM1 15.386v1.693a3.385 3.385 0 003.385 3.384h15.23A3.385 3.385 0 0023 17.08v-1.693H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol